/**
 * Lazy Auth0 config. Same rationale as `constants/API/googleAPI.ts`: this
 * module is re-exported by `constants/auth` and pulled in by unrelated
 * consumers (e.g. `UserRole`), so a missing env var would crash every story
 * that touches the auth barrel — not just the Auth0 boot path. Getters defer
 * the throw to the bootstrap-time read in `src/bootstrap.tsx`.
 *
 * Each property uses a static `process.env.REACT_APP_*` reference so Vite's
 * `define` can substitute the build-time value — `process.env[key]` with a
 * dynamic key would resolve to `undefined` against the `{}` catch-all in
 * `vite.config.ts`.
 */

const Auth0Config = {
  get domain(): string {
    const value = process.env.REACT_APP_AUTH0_DOMAIN
    if (!value) throw new Error('AUTH0_DOMAIN env variable is missing')
    return value
  },
  get clientId(): string {
    const value = process.env.REACT_APP_AUTH0_CLIENT_ID
    if (!value) throw new Error('AUTH0_CLIENT_ID env variable is missing')
    return value
  },
  get audience(): string {
    const value = process.env.REACT_APP_AUTH0_AUDIENCE
    if (!value) throw new Error('AUTH0_AUDIENCE env variable is missing')
    return value
  },
}

export default Auth0Config
